import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { fetchBrands } from "authActions.js";

let TopMenu = (props) => {

    const { fetchBrands } = props;

    const getBrands = async() => {
        await fetchBrands();
    };

    useEffect(()=> {
        getBrands();
    }, []);

    return (
        <></>
    );

};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchBrands: bindActionCreators(fetchBrands, dispatch),
        dispatch
    }
};

export default connect(null, mapDispatchToProps)(TopMenu);
